import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const fetchMonthlyInvestment = createAsyncThunk(
  "monthlyInvestment/fetchMonthlyInvestment",
  async ({ clientId, productId, investmentId, categoryId, assetId, accountId, ownerEntityId, filters, metric }, { rejectWithValue }) => {
    try {
      let url = `/account/getMonthlyInvestment?clientId=${clientId}`;

      if (metric) url += `&metric=${metric}`;
      if (productId) url += `&productId=${productId}`;
      if (investmentId) url += `&investmentId=${investmentId}`;
      if (ownerEntityId) url += `&ownerEntityId=${ownerEntityId}`;
      if (accountId) url += `&accountId=${accountId}`;
      if (categoryId) url += `&categoryId=${categoryId}`;
      if (assetId) url += `&assetId=${assetId}`;

      if (filters?.securityId) {
        url += `&productMasterId=${filters?.securityId}`;
      }

      if (filters?.accountId) {
        url += `&accountMasterId=${filters?.accountId}`;
      }

      if (filters?.investmentType) {
        url += `&investmentMasterId=${filters?.investmentType}`;
      }
      const response = await getMethod(url);
      const data = await response.json();

      if (!response.ok || data?.error) {
        return rejectWithValue(data?.error || "Failed to fetch monthly investment");
      }

      return data;

    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);


const monthlyInvestmentSlice = createSlice({
  name: "monthlyInvestment",

  initialState: {
    loading: false,
    error: null,
    monthlyInvestment: [],
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchMonthlyInvestment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchMonthlyInvestment.fulfilled, (state, action) => {
        state.loading = false;
        state.monthlyInvestment = action.payload?.data || [];
      })

      .addCase(fetchMonthlyInvestment.rejected, (state, action) => {
        state.loading = false;
        state.monthlyInvestment = [];
        state.error = action.payload || "Failed to load monthly investment";
      });
  },
});

export default monthlyInvestmentSlice.reducer;
